export default __webpack_public_path__ + "static/realWorldImg1-042a3820ff01a3c19b95148a2942dcf5.webp";